import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=05b3376f&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=ts&"
export * from "./MessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=05b3376f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3376f",
  null
  
)

export default component.exports